/*------------------------------------*\
    hover
\*------------------------------------*/
module.exports = function(){



    var $hoverElement = $('.js-hover');

    // Highlight the element matching the hovered element

    $hoverElement.hover(function() {
        var $hoverData = $(this).attr('data-hover'),
            $this = $('.js-hover[data-hover="' + $hoverData + '"]'),
            $that = $('.js-hover[data-hover="' + $hoverData + '"]').not($this);

        $this.addClass('is-active');
        $that.addClass('is-active');

        // Other sections with hover elements should remain unaffected

        $this.siblings().not($that).removeClass('is-active');
        $that.siblings().not($this).removeClass('is-active');

    });




}; // end of module.exports




// WEBPACK FOOTER //
// ./js-source/blocks/hover.js